"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_1 = require("utils/audit/hooks");
var SaaSAuditSurvey_1 = __importDefault(require("../SaaSAuditSurvey"));
var PinkBorderContainer_1 = __importDefault(require("./styles/PinkBorderContainer"));
var RequestAudit = function () {
    var _a = __read((0, hooks_1.useRequestAudit)('Dummy banner'), 3), requestAudit = _a[0], isRequestingAudit = _a[1], hasRequestedSaasAudit = _a[2];
    return ((0, jsx_runtime_1.jsxs)(PinkBorderContainer_1.default, __assign({ width: "100%" }, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center", justifyContent: "space-between" }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "This is a sample report with dummy data." })), !hasRequestedSaasAudit && ((0, jsx_runtime_1.jsx)(Button_1.default, __assign({ variant: "outlined", color: "secondary", disabled: isRequestingAudit, onClick: requestAudit }, { children: "Request an audit" })))] })), hasRequestedSaasAudit && ((0, jsx_runtime_1.jsx)(Box_1.default, __assign({ display: "inline-flex", flexDirection: "column", alignItems: "flex-start", mt: 2 }, { children: (0, jsx_runtime_1.jsx)(SaaSAuditSurvey_1.default, { fullWidthBtn: false }) })))] })));
};
exports.default = RequestAudit;
